import * as React from 'react';
import { connect } from 'react-redux';
import * as agui from 'arm-gui/dist/controls';
import { Utils, DateFormatter, UiUtils, i18n, isAuth, NumberFormatter } from 'arm-common';

export default class CheckItem extends React.Component {

    constructor(props) {
        super(props);
        this.componentName = '[CheckItem.jsx] ';
    }


    render() {
        console.log(this.componentName + "render");

        return (

            <div className={this.props.item.status === "Passed" ?
                "list-group-item list-group-item-action statusPassed" : "list-group-item list-group-item-action statusFailed"}>
                <div className="d-flex w-100 justify-content-between">
                    <h5 className="mb-1">{this.props.item.name}</h5>
                    <h5>{this.props.item.status}</h5>
                </div>
                <p className="mb-1">{this.props.item.value}</p>
                <small>{this.props.item.description}</small>
            </div>

        )
    }
};

